// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* =====================================================================
   Yantra24x7 sidebar — Linear/Vercel minimal-light redesign
   - Keeps all original class names so the JSX (sidebar.js) is unchanged
   - Calm, modern, professional look for an industrial monitoring app
   - System font stack, refined spacing, no glow/rotate animations
   ===================================================================== */

:root {
  --y-orange: #ec6e17;
  --y-orange-50: #fff7ed;
  --y-orange-100: #ffedd5;
  --y-text-900: #000;
  --y-text-700: #374151;
  --y-text-500: #6b7280;
  --y-text-400: #9ca3af;
  --y-bg: #ffffff;
  --y-bg-soft: #f9fafb;
  --y-bg-hover: #f3f4f6;
  --y-border: #e5e7eb;
  --y-shadow-card: 0 1px 2px rgba(15, 23, 42, 0.04);
  --y-font: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif;
}

/* ===== Sidebar shell ===== */
.sidebar {
  background-color: var(--y-bg);
  color: var(--y-text-700);
  font-family: var(--y-font);
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding: 8px 10px 16px;
  min-height: calc(100vh - 72px);
  max-height: calc(100vh - 72px);
  box-sizing: border-box;
  overflow-y: auto;
  overflow-x: hidden;
  scrollbar-width: thin;
  scrollbar-color: #e5e7eb transparent;
  position: fixed;
  top: 72px;             /* sit just below the navbar */
  left: 0;
  z-index: 999;
  border-right: 1px solid var(--y-border);
  width: 240px;           /* open width */
  transition: width 180ms ease, transform 180ms ease;
}
.sidebar::-webkit-scrollbar { width: 8px; }
.sidebar::-webkit-scrollbar-thumb { background: #e5e7eb; border-radius: 4px; }
.sidebar::-webkit-scrollbar-thumb:hover { background: #d1d5db; }
.sidebar::-webkit-scrollbar-track { background: transparent; }
.sidebar-closed {
  width: 64px;
  padding: 8px 4px 16px;
}

/* ===== Top section — brand header inside the sidebar ===== */
/* Modern dashboard pattern (Linear, Vercel, Notion, Linear): logo lives in
   the sidebar, not the navbar. Left-aligned, compact, professional. The
   navbar logo is hidden to avoid duplication. */
.top_section {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  padding: 6px 8px 12px;
  margin: 0 -2px 10px;
  border-bottom: 1px solid var(--y-border);
  min-height: 44px;
}
/* The JSX wraps Logo1 with stray <br/> tags — kill them so the row stays tight */
.top_section br { display: none; }

/* Hide the navbar logo entirely on desktop — sidebar carries the brand */
.Logo {
  display: none;
}
/* Sidebar logo: left-aligned, modest height, full-text logo image */
.Logo1 {
  display: block;
  height: 30px;
  width: auto;
  max-width: 100%;
  object-fit: contain;
  margin: 0;
}

/* ===== Nav items ===== */
.link {
  display: block;
  text-decoration: none;
  color: inherit;
  border-radius: 8px;
  margin: 1px 0;
}
.link:hover { text-decoration: none; }

.navlink {
  display: flex;
  align-items: center;
  gap: 14px;
  padding: 8px 12px;
  margin: 0;
  color: #000;
  font-size: 15px;
  font-weight: 400;
  letter-spacing: -0.005em;
  text-decoration: none;
  border-radius: 8px;
  transition: background-color 120ms ease, color 120ms ease;
  position: relative;
  line-height: 1.3;
}
.navlink:hover {
  background-color: transparent;
  color: var(--y-orange);
}
.navlink .icon {
  margin-right: 0;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 20px;
  height: 20px;
  font-size: 18px;
  color: #000;
  flex-shrink: 0;
  transition: color 120ms ease;
}
.navlink:hover .icon {
  color: var(--y-orange);
}
.link_text {
  font-size: 16px;
  font-family: 'Poppins', serif;
  font-weight: 400;
  color: inherit;
  letter-spacing: -0.005em;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

/* ===== Group spacing — generous vertical gap between top-level groups ===== */
.sidebar > div:not(.top_section) {
  margin-bottom: 14px;
}
.sidebar > a.link.navlink,
.sidebar > .link.navlink {
  margin-bottom: 14px;
}
/* Dropdown children: match parent group spacing so child↔child and parent↔parent
   gaps look identical */
.sidebar > div > div > .navlink {
  margin-bottom: 14px;
}
.sidebar > div > div > .navlink:last-child {
  margin-bottom: 0;
}
/* Gap between dropdown parent and its first child — match sibling gap */
.sidebar > div > div:not(.navlink) {
  margin-top: 14px;
}

/* All sidebar text uses the same weight (400) */
.sidebar > div > .navlink,
.sidebar > div > .navlink .link_text {
  font-weight: 400;
  color: #000;
}

/* ===== Active state — orange text + glowing orange box (restored from original design) ===== */
.active,
.link.active,
.navlink.active {
  color: var(--y-orange);
  border-radius: 0;
  padding: 5px 5px 5px 8px;
  border-left: 2px solid var(--y-orange);
  border-right: 2px solid var(--y-orange);
  animation: glow 1.5s infinite alternate;
  font-family: Mulish, sans-serif !important;
  background-color: transparent;
}
.active .icon,
.navlink.active .icon {
  color: var(--y-orange);
  animation: pulse 1.5s infinite;
}
.active .link_text,
.navlink.active .link_text {
  color: var(--y-orange);
}
.active .icon:hover {
  animation: rotate-vertical 1.1s infinite;
}

@keyframes glow {
  0%   { box-shadow: 0 0 5px 0 var(--y-orange); }
  50%  { box-shadow: 0 0 10px 0 var(--y-orange); }
  100% { box-shadow: 0 0 5px 0 var(--y-orange); }
}
@keyframes pulse {
  0%   { transform: scale(1); }
  50%  { transform: scale(1.1); }
  100% { transform: scale(1); }
}
@keyframes rotate-vertical {
  0%   { transform: rotateY(0deg); }
  100% { transform: rotateY(360deg); }
}

/* ===== Hover — orange text only, no box (original behavior) ===== */
.link_text:hover { color: var(--y-orange); }

/* ===== Sidebar-closed (icon-only) tweaks ===== */
.sidebar-closed .navlink {
  justify-content: center;
  padding: 10px 0;
}
.sidebar-closed .navlink .icon { margin-right: 0; }
.sidebar-closed .link_text { display: none; }
/* Collapsed rail: SVG icon (Yantra mark) centered, narrower header */
.sidebar-closed .top_section {
  justify-content: center;
  padding: 8px 0 10px;
  margin: 0 0 8px;
}
.sidebar-closed .LogoIcon {
  display: block;
  height: 32px;
  width: 32px;
  object-fit: contain;
}
.sidebar-closed .navlink.active::before { display: none; }
/* The full PNG logo is the OPEN-mode mark; the LogoIcon SVG is the
   COLLAPSED-mode mark. The JSX renders only one at a time. */
.LogoIcon {
  display: block;
  height: 32px;
  width: 32px;
  object-fit: contain;
}
.sidebar-closed .navlink.active {
  background-color: var(--y-orange-50);
  border-radius: 10px;
}

/* ===== Top navbar =====
   Specificity-boosted (nav.navbar.navbar) and !important on background to win
   against react-bootstrap's default Navbar styles that otherwise leave the
   header transparent → page content bleeds through visibly. */
nav.navbar,
.navbar.navbar {
  width: 100% !important;
  background-color: var(--y-bg) !important;
  background-clip: padding-box;
  color: var(--y-text-900);
  padding: 0 18px !important;
  height: 72px !important;
  min-height: 72px !important;
  display: flex;
  align-items: center;
  border-bottom: 1px solid var(--y-border);
  position: fixed !important;
  top: 0;
  left: 0;
  right: 0;
  z-index: 1000 !important;
  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.03);
  font-family: var(--y-font);
  opacity: 1 !important;
}
.navbarcontent {
  display: flex;
  align-items: center;
  width: 100%;
  gap: 18px;
}
.navbarcontent > * { flex-shrink: 0; }
.navbarcontent span {
  text-align: left;
  font-size: 14px;
  color: var(--y-text-700);
  font-weight: 500;
}
.menu-icon {
  font-size: 20px;
  cursor: pointer;
  color: var(--y-text-700);
  padding: 6px 8px;
  border-radius: 6px;
  transition: background-color 120ms ease, color 120ms ease;
}
.menu-icon:hover {
  background-color: var(--y-bg-hover);
  color: var(--y-text-900);
}

/* ===== Right side of navbar (user + logout) ===== */
.rightsidecontents {
  display: flex;
  align-items: center;
  margin-left: auto;
  gap: 14px;
  font-family: var(--y-font);
}
.rightsidecontents p {
  margin: 0;
  font-size: 13px;
  color: var(--y-text-700);
  font-weight: 500;
}
.person {
  cursor: pointer;
  color: var(--y-text-700);
  font-size: 13px;
  font-weight: 500;
  padding: 6px 10px;
  border-radius: 6px;
  transition: background-color 120ms ease;
}
.person:hover {
  background-color: var(--y-bg-hover);
}
.circles-icon {
  font-size: 20px;
  cursor: pointer;
  color: var(--y-text-500);
  padding: 6px 8px;
  border-radius: 6px;
  transition: color 120ms ease, background-color 120ms ease;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}
.circles-icon:hover {
  color: #dc2626;
  background-color: #fee2e2;
}

/* ===== Main content area ===== */
.container {
  display: flex;
  flex-direction: column;
  margin-top: 72px;
}
.content {
  display: flex;
  margin-left: 64px;
  transition: margin-left 180ms ease;
}
.sidebar-open + .content {
  margin-left: 240px;
}
#sidebar-open.pages {
  padding-left: 240px;
}
.main-content {
  flex-grow: 1;
  width: 100%;
  /* 72px navbar + 16px breathing room — page content was being hidden behind the fixed navbar */
  padding-block-start: 82px;
  padding-bottom: 0;
  overflow-x: hidden;
  scrollbar-width: thin;
  background-color: #fafafa;
  min-height: 100vh;
  box-sizing: border-box;
}

/* ===== Footer ===== */
.footer {
  background-color: var(--y-bg);
  color: var(--y-text-500);
  padding: 8px 16px;
  text-align: right;
  position: fixed;
  width: 100%;
  bottom: 0;
  border-top: 1px solid var(--y-border);
  z-index: 999;
  font-size: 12px;
  font-family: var(--y-font);
}

/* ===== Responsive ===== */
@media (max-width: 768px) {
  .main-content { padding: 0 !important; }
  /* On mobile the sidebar drawer shows the logo when open (navbar already
     has no logo). */
  .Logo { display: none; }
  .Logo1 {
    display: block;
    height: 30px;
    width: auto;
    max-width: 120px;
  }
  .top_section {
    padding: 6px 8px 10px;
    border-bottom: 1px solid var(--y-border);
    margin: 0 -2px 8px;
  }
  .person { display: none; }
  .rightsidecontents { padding-right: 12px; gap: 8px; }
  .navbarcontent span { font-size: 13px; }
  .navbarcontent .menu-icon { margin-right: 0; }
  .navbarcontent { gap: 8px; }
  .circles-icon { color: var(--y-orange); margin-right: 0; }
  .sidebar-closed { display: none; }
  .sidebar {
    z-index: 1200;
    box-shadow: 4px 0 16px rgba(15, 23, 42, 0.08);
  }
}

/* ============================================================
   VELPLAST-STYLE SECTIONS — flat group headers, no dropdowns
   ============================================================ */
.sidebar-section {
  margin: 4px 0 6px;
  display: flex;
  flex-direction: column;
  gap: 1px;
}
.sidebar-section-header {
  font-size: 10.5px;
  font-weight: 700;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: var(--y-text-400);
  padding: 14px 12px 4px;
  -webkit-user-select: none;
          user-select: none;
}
.sidebar-closed .sidebar-section-header {
  display: none;
}
.sidebar-closed .sidebar-section {
  border-top: 1px solid var(--y-border);
  margin-top: 10px;
  padding-top: 8px;
}

/* Section items — velplast active state */
.section-item {
  position: relative;
  border-radius: 8px;
  font-size: 13.5px;
  font-weight: 500;
  color: var(--y-text-700);
  transition: background-color 120ms ease, color 120ms ease;
  margin: 0;
  width: 100%;
  box-sizing: border-box;
}
.section-item:hover {
  background-color: var(--y-bg-hover);
  color: var(--y-text-900);
}
.section-item .icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 18px;
  height: 18px;
  font-size: 17px;
  color: var(--y-text-500);
  flex-shrink: 0;
  transition: color 120ms ease;
}
.section-item:hover .icon {
  color: var(--y-text-700);
}
.section-item.active {
  background-color: var(--y-orange-50);
  color: var(--y-orange);
  font-weight: 600;
  box-shadow: 0 2px 8px -3px rgba(236, 110, 23, 0.15);
}
.section-item.active .icon {
  color: var(--y-orange);
}
.section-item.active::before {
  content: '';
  position: absolute;
  left: 0;
  top: 50%;
  transform: translateY(-50%);
  width: 3px;
  height: 22px;
  background: var(--y-orange);
  border-radius: 0 3px 3px 0;
}
.section-item .link_text {
  color: inherit;
  font: inherit;
}
.sidebar-closed .section-item {
  padding: 8px !important;
  justify-content: center;
}
.sidebar-closed .section-item .link_text {
  display: none;
}

/* ============================================================
   Header controls: language switcher + dark mode toggle
   ============================================================ */
.lang-switcher {
  position: relative;
  display: inline-flex;
  align-items: center;
  gap: 5px;
  padding: 5px 9px;
  border-radius: 8px;
  border: 1px solid var(--y-border);
  background: var(--y-bg);
  color: var(--y-text-700);
  cursor: pointer;
  font-size: 13px;
  font-weight: 600;
  -webkit-user-select: none;
          user-select: none;
  transition: background-color 120ms ease, border-color 120ms ease;
}
.lang-switcher:hover {
  background: var(--y-bg-hover);
  border-color: var(--y-orange);
}
.lang-switcher .lang-label {
  font-size: 12px;
  letter-spacing: 0.02em;
}
.lang-menu {
  position: absolute;
  top: calc(100% + 6px);
  right: 0;
  background: var(--y-bg);
  border: 1px solid var(--y-border);
  border-radius: 10px;
  box-shadow: 0 8px 24px rgba(15, 23, 42, 0.12);
  padding: 4px;
  z-index: 1300;
  min-width: 140px;
  display: flex;
  flex-direction: column;
  gap: 2px;
}
.lang-menu-item {
  background: transparent;
  border: 0;
  padding: 9px 12px;
  text-align: left;
  border-radius: 6px;
  cursor: pointer;
  font-size: 13px;
  color: var(--y-text-700);
  transition: background-color 120ms ease;
}
.lang-menu-item:hover {
  background: var(--y-bg-hover);
}
.lang-menu-item.active {
  background: var(--y-orange-50);
  color: var(--y-orange);
  font-weight: 600;
}

.theme-toggle {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  border-radius: 8px;
  border: 1px solid var(--y-border);
  background: var(--y-bg);
  color: var(--y-text-700);
  font-size: 18px;
  transition: background-color 120ms ease, border-color 120ms ease, color 120ms ease;
}
.theme-toggle:hover {
  background: var(--y-bg-hover);
  border-color: var(--y-orange);
  color: var(--y-orange);
}

/* ============================================================
   DARK MODE — flips the same CSS variables; everything follows
   ============================================================ */
body[data-theme="dark"] {
  --y-text-900: #f1f5f9;
  --y-text-700: #cbd5e1;
  --y-text-500: #94a3b8;
  --y-text-400: #64748b;
  --y-bg: #0f172a;
  --y-bg-soft: #1e293b;
  --y-bg-hover: #1e293b;
  --y-border: #334155;
  --y-orange-50: rgba(236, 110, 23, 0.12);
  --y-orange-100: rgba(236, 110, 23, 0.22);
}
body[data-theme="dark"] {
  background-color: var(--y-bg);
  color: var(--y-text-700);
}
body[data-theme="dark"] .navbar {
  background-color: var(--y-bg);
  border-bottom: 1px solid var(--y-border);
}
body[data-theme="dark"] .navbarcontent {
  color: var(--y-text-700);
}
body[data-theme="dark"] .navbarcontent button,
body[data-theme="dark"] .navbarcontent h6,
body[data-theme="dark"] .navbarcontent p,
body[data-theme="dark"] .navbarcontent span {
  color: var(--y-text-700);
}
body[data-theme="dark"] .sidebar {
  background-color: var(--y-bg);
  border-right: 1px solid var(--y-border);
}
body[data-theme="dark"] .section-item,
body[data-theme="dark"] .section-item .link_text,
body[data-theme="dark"] .section-item span,
body[data-theme="dark"] .sidebar a.section-item {
  color: #e2e8f0 !important;
}
body[data-theme="dark"] .section-item .icon,
body[data-theme="dark"] .section-item .icon svg {
  color: #cbd5e1 !important;
  fill: #cbd5e1 !important;
}
body[data-theme="dark"] .section-item:hover,
body[data-theme="dark"] .section-item:hover .link_text {
  color: #ffffff !important;
  background-color: #1e293b !important;
}
body[data-theme="dark"] .section-item:hover .icon,
body[data-theme="dark"] .section-item:hover .icon svg {
  color: #ffffff !important;
  fill: #ffffff !important;
}
body[data-theme="dark"] .section-item.active,
body[data-theme="dark"] .section-item.active .link_text,
body[data-theme="dark"] .section-item.active span {
  color: #fb923c !important;
  background-color: rgba(236, 110, 23, 0.18) !important;
}
body[data-theme="dark"] .section-item.active .icon,
body[data-theme="dark"] .section-item.active .icon svg {
  color: #fb923c !important;
  fill: #fb923c !important;
}
body[data-theme="dark"] .sidebar-section-header {
  color: #94a3b8 !important;
}
body[data-theme="dark"] .section-item:hover {
  background-color: var(--y-bg-hover);
  color: var(--y-text-900);
}
body[data-theme="dark"] .section-item.active {
  background-color: var(--y-orange-100);
  color: var(--y-orange);
}
body[data-theme="dark"] .sidebar-section-header {
  color: var(--y-text-400);
}

`, "",{"version":3,"sources":["webpack://./src/app/Nav/sidebars.css"],"names":[],"mappings":"AAAA;;;;;0EAK0E;;AAE1E;EACE,mBAAmB;EACnB,sBAAsB;EACtB,uBAAuB;EACvB,kBAAkB;EAClB,qBAAqB;EACrB,qBAAqB;EACrB,qBAAqB;EACrB,eAAe;EACf,oBAAoB;EACpB,qBAAqB;EACrB,mBAAmB;EACnB,iDAAiD;EACjD,oGAAoG;AACtG;;AAEA,8BAA8B;AAC9B;EACE,6BAA6B;EAC7B,wBAAwB;EACxB,0BAA0B;EAC1B,aAAa;EACb,sBAAsB;EACtB,8BAA8B;EAC9B,sBAAsB;EACtB,8BAA8B;EAC9B,8BAA8B;EAC9B,sBAAsB;EACtB,gBAAgB;EAChB,kBAAkB;EAClB,qBAAqB;EACrB,oCAAoC;EACpC,eAAe;EACf,SAAS,cAAc,8BAA8B;EACrD,OAAO;EACP,YAAY;EACZ,uCAAuC;EACvC,YAAY,YAAY,eAAe;EACvC,kDAAkD;AACpD;AACA,8BAA8B,UAAU,EAAE;AAC1C,oCAAoC,mBAAmB,EAAE,kBAAkB,EAAE;AAC7E,0CAA0C,mBAAmB,EAAE;AAC/D,oCAAoC,uBAAuB,EAAE;AAC7D;EACE,WAAW;EACX,qBAAqB;AACvB;;AAEA,8DAA8D;AAC9D;;gDAEgD;AAChD;EACE,aAAa;EACb,mBAAmB;EACnB,2BAA2B;EAC3B,qBAAqB;EACrB,mBAAmB;EACnB,wCAAwC;EACxC,gBAAgB;AAClB;AACA,iFAAiF;AACjF,kBAAkB,aAAa,EAAE;;AAEjC,yEAAyE;AACzE;EACE,aAAa;AACf;AACA,oEAAoE;AACpE;EACE,cAAc;EACd,YAAY;EACZ,WAAW;EACX,eAAe;EACf,mBAAmB;EACnB,SAAS;AACX;;AAEA,0BAA0B;AAC1B;EACE,cAAc;EACd,qBAAqB;EACrB,cAAc;EACd,kBAAkB;EAClB,aAAa;AACf;AACA,cAAc,qBAAqB,EAAE;;AAErC;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,iBAAiB;EACjB,SAAS;EACT,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,wBAAwB;EACxB,qBAAqB;EACrB,kBAAkB;EAClB,yDAAyD;EACzD,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,6BAA6B;EAC7B,sBAAsB;AACxB;AACA;EACE,eAAe;EACf,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,eAAe;EACf,WAAW;EACX,cAAc;EACd,4BAA4B;AAC9B;AACA;EACE,sBAAsB;AACxB;AACA;EACE,eAAe;EACf,6BAA6B;EAC7B,gBAAgB;EAChB,cAAc;EACd,wBAAwB;EACxB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA,+EAA+E;AAC/E;EACE,mBAAmB;AACrB;AACA;;EAEE,mBAAmB;AACrB;AACA;wBACwB;AACxB;EACE,mBAAmB;AACrB;AACA;EACE,gBAAgB;AAClB;AACA,wEAAwE;AACxE;EACE,gBAAgB;AAClB;;AAEA,gDAAgD;AAChD;;EAEE,gBAAgB;EAChB,WAAW;AACb;;AAEA,gGAAgG;AAChG;;;EAGE,sBAAsB;EACtB,gBAAgB;EAChB,wBAAwB;EACxB,sCAAsC;EACtC,uCAAuC;EACvC,uCAAuC;EACvC,0CAA0C;EAC1C,6BAA6B;AAC/B;AACA;;EAEE,sBAAsB;EACtB,8BAA8B;AAChC;AACA;;EAEE,sBAAsB;AACxB;AACA;EACE,wCAAwC;AAC1C;;AAEA;EACE,OAAO,qCAAqC,EAAE;EAC9C,OAAO,sCAAsC,EAAE;EAC/C,OAAO,qCAAqC,EAAE;AAChD;AACA;EACE,OAAO,mBAAmB,EAAE;EAC5B,OAAO,qBAAqB,EAAE;EAC9B,OAAO,mBAAmB,EAAE;AAC9B;AACA;EACE,OAAO,wBAAwB,EAAE;EACjC,OAAO,0BAA0B,EAAE;AACrC;;AAEA,qEAAqE;AACrE,mBAAmB,sBAAsB,EAAE;;AAE3C,kDAAkD;AAClD;EACE,uBAAuB;EACvB,eAAe;AACjB;AACA,iCAAiC,eAAe,EAAE;AAClD,6BAA6B,aAAa,EAAE;AAC5C,qEAAqE;AACrE;EACE,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;AACjB;AACA;EACE,cAAc;EACd,YAAY;EACZ,WAAW;EACX,mBAAmB;AACrB;AACA,0CAA0C,aAAa,EAAE;AACzD;6DAC6D;AAC7D;EACE,cAAc;EACd,YAAY;EACZ,WAAW;EACX,mBAAmB;AACrB;AACA;EACE,oCAAoC;EACpC,mBAAmB;AACrB;;AAEA;;;8DAG8D;AAC9D;;EAEE,sBAAsB;EACtB,wCAAwC;EACxC,4BAA4B;EAC5B,wBAAwB;EACxB,0BAA0B;EAC1B,uBAAuB;EACvB,2BAA2B;EAC3B,aAAa;EACb,mBAAmB;EACnB,wCAAwC;EACxC,0BAA0B;EAC1B,MAAM;EACN,OAAO;EACP,QAAQ;EACR,wBAAwB;EACxB,4CAA4C;EAC5C,0BAA0B;EAC1B,qBAAqB;AACvB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,SAAS;AACX;AACA,qBAAqB,cAAc,EAAE;AACrC;EACE,gBAAgB;EAChB,eAAe;EACf,wBAAwB;EACxB,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,eAAe;EACf,wBAAwB;EACxB,gBAAgB;EAChB,kBAAkB;EAClB,yDAAyD;AAC3D;AACA;EACE,mCAAmC;EACnC,wBAAwB;AAC1B;;AAEA,qDAAqD;AACrD;EACE,aAAa;EACb,mBAAmB;EACnB,iBAAiB;EACjB,SAAS;EACT,0BAA0B;AAC5B;AACA;EACE,SAAS;EACT,eAAe;EACf,wBAAwB;EACxB,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,wBAAwB;EACxB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,uCAAuC;AACzC;AACA;EACE,mCAAmC;AACrC;AACA;EACE,eAAe;EACf,eAAe;EACf,wBAAwB;EACxB,gBAAgB;EAChB,kBAAkB;EAClB,yDAAyD;EACzD,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,cAAc;EACd,yBAAyB;AAC3B;;AAEA,kCAAkC;AAClC;EACE,aAAa;EACb,sBAAsB;EACtB,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,iBAAiB;EACjB,kCAAkC;AACpC;AACA;EACE,kBAAkB;AACpB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,YAAY;EACZ,WAAW;EACX,8FAA8F;EAC9F,yBAAyB;EACzB,iBAAiB;EACjB,kBAAkB;EAClB,qBAAqB;EACrB,yBAAyB;EACzB,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA,uBAAuB;AACvB;EACE,6BAA6B;EAC7B,wBAAwB;EACxB,iBAAiB;EACjB,iBAAiB;EACjB,eAAe;EACf,WAAW;EACX,SAAS;EACT,qCAAqC;EACrC,YAAY;EACZ,eAAe;EACf,0BAA0B;AAC5B;;AAEA,2BAA2B;AAC3B;EACE,gBAAgB,qBAAqB,EAAE;EACvC;oBACkB;EAClB,QAAQ,aAAa,EAAE;EACvB;IACE,cAAc;IACd,YAAY;IACZ,WAAW;IACX,gBAAgB;EAClB;EACA;IACE,qBAAqB;IACrB,wCAAwC;IACxC,kBAAkB;EACpB;EACA,UAAU,aAAa,EAAE;EACzB,qBAAqB,mBAAmB,EAAE,QAAQ,EAAE;EACpD,sBAAsB,eAAe,EAAE;EACvC,4BAA4B,eAAe,EAAE;EAC7C,iBAAiB,QAAQ,EAAE;EAC3B,gBAAgB,sBAAsB,EAAE,eAAe,EAAE;EACzD,kBAAkB,aAAa,EAAE;EACjC;IACE,aAAa;IACb,6CAA6C;EAC/C;AACF;;AAEA;;iEAEiE;AACjE;EACE,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;AACA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,wBAAwB;EACxB,sBAAsB;EACtB,yBAAiB;UAAjB,iBAAiB;AACnB;AACA;EACE,aAAa;AACf;AACA;EACE,qCAAqC;EACrC,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA,0CAA0C;AAC1C;EACE,kBAAkB;EAClB,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,wBAAwB;EACxB,yDAAyD;EACzD,SAAS;EACT,WAAW;EACX,sBAAsB;AACxB;AACA;EACE,mCAAmC;EACnC,wBAAwB;AAC1B;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,eAAe;EACf,wBAAwB;EACxB,cAAc;EACd,4BAA4B;AAC9B;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,oCAAoC;EACpC,sBAAsB;EACtB,gBAAgB;EAChB,mDAAmD;AACrD;AACA;EACE,sBAAsB;AACxB;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,OAAO;EACP,QAAQ;EACR,2BAA2B;EAC3B,UAAU;EACV,YAAY;EACZ,2BAA2B;EAC3B,0BAA0B;AAC5B;AACA;EACE,cAAc;EACd,aAAa;AACf;AACA;EACE,uBAAuB;EACvB,uBAAuB;AACzB;AACA;EACE,aAAa;AACf;;AAEA;;iEAEiE;AACjE;EACE,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,kBAAkB;EAClB,iCAAiC;EACjC,uBAAuB;EACvB,wBAAwB;EACxB,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,yBAAiB;UAAjB,iBAAiB;EACjB,gEAAgE;AAClE;AACA;EACE,6BAA6B;EAC7B,6BAA6B;AAC/B;AACA;EACE,eAAe;EACf,sBAAsB;AACxB;AACA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,QAAQ;EACR,uBAAuB;EACvB,iCAAiC;EACjC,mBAAmB;EACnB,6CAA6C;EAC7C,YAAY;EACZ,aAAa;EACb,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;AACA;EACE,uBAAuB;EACvB,SAAS;EACT,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,wBAAwB;EACxB,uCAAuC;AACzC;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,8BAA8B;EAC9B,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,iCAAiC;EACjC,uBAAuB;EACvB,wBAAwB;EACxB,eAAe;EACf,kFAAkF;AACpF;AACA;EACE,6BAA6B;EAC7B,6BAA6B;EAC7B,sBAAsB;AACxB;;AAEA;;iEAEiE;AACjE;EACE,qBAAqB;EACrB,qBAAqB;EACrB,qBAAqB;EACrB,qBAAqB;EACrB,eAAe;EACf,oBAAoB;EACpB,qBAAqB;EACrB,mBAAmB;EACnB,uCAAuC;EACvC,wCAAwC;AAC1C;AACA;EACE,6BAA6B;EAC7B,wBAAwB;AAC1B;AACA;EACE,6BAA6B;EAC7B,wCAAwC;AAC1C;AACA;EACE,wBAAwB;AAC1B;AACA;;;;EAIE,wBAAwB;AAC1B;AACA;EACE,6BAA6B;EAC7B,uCAAuC;AACzC;AACA;;;;EAIE,yBAAyB;AAC3B;AACA;;EAEE,yBAAyB;EACzB,wBAAwB;AAC1B;AACA;;EAEE,yBAAyB;EACzB,oCAAoC;AACtC;AACA;;EAEE,yBAAyB;EACzB,wBAAwB;AAC1B;AACA;;;EAGE,yBAAyB;EACzB,qDAAqD;AACvD;AACA;;EAEE,yBAAyB;EACzB,wBAAwB;AAC1B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,mCAAmC;EACnC,wBAAwB;AAC1B;AACA;EACE,qCAAqC;EACrC,sBAAsB;AACxB;AACA;EACE,wBAAwB;AAC1B","sourcesContent":["/* =====================================================================\n   Yantra24x7 sidebar — Linear/Vercel minimal-light redesign\n   - Keeps all original class names so the JSX (sidebar.js) is unchanged\n   - Calm, modern, professional look for an industrial monitoring app\n   - System font stack, refined spacing, no glow/rotate animations\n   ===================================================================== */\n\n:root {\n  --y-orange: #ec6e17;\n  --y-orange-50: #fff7ed;\n  --y-orange-100: #ffedd5;\n  --y-text-900: #000;\n  --y-text-700: #374151;\n  --y-text-500: #6b7280;\n  --y-text-400: #9ca3af;\n  --y-bg: #ffffff;\n  --y-bg-soft: #f9fafb;\n  --y-bg-hover: #f3f4f6;\n  --y-border: #e5e7eb;\n  --y-shadow-card: 0 1px 2px rgba(15, 23, 42, 0.04);\n  --y-font: -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, \"Helvetica Neue\", Arial, sans-serif;\n}\n\n/* ===== Sidebar shell ===== */\n.sidebar {\n  background-color: var(--y-bg);\n  color: var(--y-text-700);\n  font-family: var(--y-font);\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  padding: 8px 10px 16px;\n  min-height: calc(100vh - 72px);\n  max-height: calc(100vh - 72px);\n  box-sizing: border-box;\n  overflow-y: auto;\n  overflow-x: hidden;\n  scrollbar-width: thin;\n  scrollbar-color: #e5e7eb transparent;\n  position: fixed;\n  top: 72px;             /* sit just below the navbar */\n  left: 0;\n  z-index: 999;\n  border-right: 1px solid var(--y-border);\n  width: 240px;           /* open width */\n  transition: width 180ms ease, transform 180ms ease;\n}\n.sidebar::-webkit-scrollbar { width: 8px; }\n.sidebar::-webkit-scrollbar-thumb { background: #e5e7eb; border-radius: 4px; }\n.sidebar::-webkit-scrollbar-thumb:hover { background: #d1d5db; }\n.sidebar::-webkit-scrollbar-track { background: transparent; }\n.sidebar-closed {\n  width: 64px;\n  padding: 8px 4px 16px;\n}\n\n/* ===== Top section — brand header inside the sidebar ===== */\n/* Modern dashboard pattern (Linear, Vercel, Notion, Linear): logo lives in\n   the sidebar, not the navbar. Left-aligned, compact, professional. The\n   navbar logo is hidden to avoid duplication. */\n.top_section {\n  display: flex;\n  align-items: center;\n  justify-content: flex-start;\n  padding: 6px 8px 12px;\n  margin: 0 -2px 10px;\n  border-bottom: 1px solid var(--y-border);\n  min-height: 44px;\n}\n/* The JSX wraps Logo1 with stray <br/> tags — kill them so the row stays tight */\n.top_section br { display: none; }\n\n/* Hide the navbar logo entirely on desktop — sidebar carries the brand */\n.Logo {\n  display: none;\n}\n/* Sidebar logo: left-aligned, modest height, full-text logo image */\n.Logo1 {\n  display: block;\n  height: 30px;\n  width: auto;\n  max-width: 100%;\n  object-fit: contain;\n  margin: 0;\n}\n\n/* ===== Nav items ===== */\n.link {\n  display: block;\n  text-decoration: none;\n  color: inherit;\n  border-radius: 8px;\n  margin: 1px 0;\n}\n.link:hover { text-decoration: none; }\n\n.navlink {\n  display: flex;\n  align-items: center;\n  gap: 14px;\n  padding: 8px 12px;\n  margin: 0;\n  color: #000;\n  font-size: 15px;\n  font-weight: 400;\n  letter-spacing: -0.005em;\n  text-decoration: none;\n  border-radius: 8px;\n  transition: background-color 120ms ease, color 120ms ease;\n  position: relative;\n  line-height: 1.3;\n}\n.navlink:hover {\n  background-color: transparent;\n  color: var(--y-orange);\n}\n.navlink .icon {\n  margin-right: 0;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 20px;\n  height: 20px;\n  font-size: 18px;\n  color: #000;\n  flex-shrink: 0;\n  transition: color 120ms ease;\n}\n.navlink:hover .icon {\n  color: var(--y-orange);\n}\n.link_text {\n  font-size: 16px;\n  font-family: 'Poppins', serif;\n  font-weight: 400;\n  color: inherit;\n  letter-spacing: -0.005em;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n/* ===== Group spacing — generous vertical gap between top-level groups ===== */\n.sidebar > div:not(.top_section) {\n  margin-bottom: 14px;\n}\n.sidebar > a.link.navlink,\n.sidebar > .link.navlink {\n  margin-bottom: 14px;\n}\n/* Dropdown children: match parent group spacing so child↔child and parent↔parent\n   gaps look identical */\n.sidebar > div > div > .navlink {\n  margin-bottom: 14px;\n}\n.sidebar > div > div > .navlink:last-child {\n  margin-bottom: 0;\n}\n/* Gap between dropdown parent and its first child — match sibling gap */\n.sidebar > div > div:not(.navlink) {\n  margin-top: 14px;\n}\n\n/* All sidebar text uses the same weight (400) */\n.sidebar > div > .navlink,\n.sidebar > div > .navlink .link_text {\n  font-weight: 400;\n  color: #000;\n}\n\n/* ===== Active state — orange text + glowing orange box (restored from original design) ===== */\n.active,\n.link.active,\n.navlink.active {\n  color: var(--y-orange);\n  border-radius: 0;\n  padding: 5px 5px 5px 8px;\n  border-left: 2px solid var(--y-orange);\n  border-right: 2px solid var(--y-orange);\n  animation: glow 1.5s infinite alternate;\n  font-family: Mulish, sans-serif !important;\n  background-color: transparent;\n}\n.active .icon,\n.navlink.active .icon {\n  color: var(--y-orange);\n  animation: pulse 1.5s infinite;\n}\n.active .link_text,\n.navlink.active .link_text {\n  color: var(--y-orange);\n}\n.active .icon:hover {\n  animation: rotate-vertical 1.1s infinite;\n}\n\n@keyframes glow {\n  0%   { box-shadow: 0 0 5px 0 var(--y-orange); }\n  50%  { box-shadow: 0 0 10px 0 var(--y-orange); }\n  100% { box-shadow: 0 0 5px 0 var(--y-orange); }\n}\n@keyframes pulse {\n  0%   { transform: scale(1); }\n  50%  { transform: scale(1.1); }\n  100% { transform: scale(1); }\n}\n@keyframes rotate-vertical {\n  0%   { transform: rotateY(0deg); }\n  100% { transform: rotateY(360deg); }\n}\n\n/* ===== Hover — orange text only, no box (original behavior) ===== */\n.link_text:hover { color: var(--y-orange); }\n\n/* ===== Sidebar-closed (icon-only) tweaks ===== */\n.sidebar-closed .navlink {\n  justify-content: center;\n  padding: 10px 0;\n}\n.sidebar-closed .navlink .icon { margin-right: 0; }\n.sidebar-closed .link_text { display: none; }\n/* Collapsed rail: SVG icon (Yantra mark) centered, narrower header */\n.sidebar-closed .top_section {\n  justify-content: center;\n  padding: 8px 0 10px;\n  margin: 0 0 8px;\n}\n.sidebar-closed .LogoIcon {\n  display: block;\n  height: 32px;\n  width: 32px;\n  object-fit: contain;\n}\n.sidebar-closed .navlink.active::before { display: none; }\n/* The full PNG logo is the OPEN-mode mark; the LogoIcon SVG is the\n   COLLAPSED-mode mark. The JSX renders only one at a time. */\n.LogoIcon {\n  display: block;\n  height: 32px;\n  width: 32px;\n  object-fit: contain;\n}\n.sidebar-closed .navlink.active {\n  background-color: var(--y-orange-50);\n  border-radius: 10px;\n}\n\n/* ===== Top navbar =====\n   Specificity-boosted (nav.navbar.navbar) and !important on background to win\n   against react-bootstrap's default Navbar styles that otherwise leave the\n   header transparent → page content bleeds through visibly. */\nnav.navbar,\n.navbar.navbar {\n  width: 100% !important;\n  background-color: var(--y-bg) !important;\n  background-clip: padding-box;\n  color: var(--y-text-900);\n  padding: 0 18px !important;\n  height: 72px !important;\n  min-height: 72px !important;\n  display: flex;\n  align-items: center;\n  border-bottom: 1px solid var(--y-border);\n  position: fixed !important;\n  top: 0;\n  left: 0;\n  right: 0;\n  z-index: 1000 !important;\n  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.03);\n  font-family: var(--y-font);\n  opacity: 1 !important;\n}\n.navbarcontent {\n  display: flex;\n  align-items: center;\n  width: 100%;\n  gap: 18px;\n}\n.navbarcontent > * { flex-shrink: 0; }\n.navbarcontent span {\n  text-align: left;\n  font-size: 14px;\n  color: var(--y-text-700);\n  font-weight: 500;\n}\n.menu-icon {\n  font-size: 20px;\n  cursor: pointer;\n  color: var(--y-text-700);\n  padding: 6px 8px;\n  border-radius: 6px;\n  transition: background-color 120ms ease, color 120ms ease;\n}\n.menu-icon:hover {\n  background-color: var(--y-bg-hover);\n  color: var(--y-text-900);\n}\n\n/* ===== Right side of navbar (user + logout) ===== */\n.rightsidecontents {\n  display: flex;\n  align-items: center;\n  margin-left: auto;\n  gap: 14px;\n  font-family: var(--y-font);\n}\n.rightsidecontents p {\n  margin: 0;\n  font-size: 13px;\n  color: var(--y-text-700);\n  font-weight: 500;\n}\n.person {\n  cursor: pointer;\n  color: var(--y-text-700);\n  font-size: 13px;\n  font-weight: 500;\n  padding: 6px 10px;\n  border-radius: 6px;\n  transition: background-color 120ms ease;\n}\n.person:hover {\n  background-color: var(--y-bg-hover);\n}\n.circles-icon {\n  font-size: 20px;\n  cursor: pointer;\n  color: var(--y-text-500);\n  padding: 6px 8px;\n  border-radius: 6px;\n  transition: color 120ms ease, background-color 120ms ease;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n}\n.circles-icon:hover {\n  color: #dc2626;\n  background-color: #fee2e2;\n}\n\n/* ===== Main content area ===== */\n.container {\n  display: flex;\n  flex-direction: column;\n  margin-top: 72px;\n}\n.content {\n  display: flex;\n  margin-left: 64px;\n  transition: margin-left 180ms ease;\n}\n.sidebar-open + .content {\n  margin-left: 240px;\n}\n#sidebar-open.pages {\n  padding-left: 240px;\n}\n.main-content {\n  flex-grow: 1;\n  width: 100%;\n  /* 72px navbar + 16px breathing room — page content was being hidden behind the fixed navbar */\n  padding-block-start: 82px;\n  padding-bottom: 0;\n  overflow-x: hidden;\n  scrollbar-width: thin;\n  background-color: #fafafa;\n  min-height: 100vh;\n  box-sizing: border-box;\n}\n\n/* ===== Footer ===== */\n.footer {\n  background-color: var(--y-bg);\n  color: var(--y-text-500);\n  padding: 8px 16px;\n  text-align: right;\n  position: fixed;\n  width: 100%;\n  bottom: 0;\n  border-top: 1px solid var(--y-border);\n  z-index: 999;\n  font-size: 12px;\n  font-family: var(--y-font);\n}\n\n/* ===== Responsive ===== */\n@media (max-width: 768px) {\n  .main-content { padding: 0 !important; }\n  /* On mobile the sidebar drawer shows the logo when open (navbar already\n     has no logo). */\n  .Logo { display: none; }\n  .Logo1 {\n    display: block;\n    height: 30px;\n    width: auto;\n    max-width: 120px;\n  }\n  .top_section {\n    padding: 6px 8px 10px;\n    border-bottom: 1px solid var(--y-border);\n    margin: 0 -2px 8px;\n  }\n  .person { display: none; }\n  .rightsidecontents { padding-right: 12px; gap: 8px; }\n  .navbarcontent span { font-size: 13px; }\n  .navbarcontent .menu-icon { margin-right: 0; }\n  .navbarcontent { gap: 8px; }\n  .circles-icon { color: var(--y-orange); margin-right: 0; }\n  .sidebar-closed { display: none; }\n  .sidebar {\n    z-index: 1200;\n    box-shadow: 4px 0 16px rgba(15, 23, 42, 0.08);\n  }\n}\n\n/* ============================================================\n   VELPLAST-STYLE SECTIONS — flat group headers, no dropdowns\n   ============================================================ */\n.sidebar-section {\n  margin: 4px 0 6px;\n  display: flex;\n  flex-direction: column;\n  gap: 1px;\n}\n.sidebar-section-header {\n  font-size: 10.5px;\n  font-weight: 700;\n  letter-spacing: 0.06em;\n  text-transform: uppercase;\n  color: var(--y-text-400);\n  padding: 14px 12px 4px;\n  user-select: none;\n}\n.sidebar-closed .sidebar-section-header {\n  display: none;\n}\n.sidebar-closed .sidebar-section {\n  border-top: 1px solid var(--y-border);\n  margin-top: 10px;\n  padding-top: 8px;\n}\n\n/* Section items — velplast active state */\n.section-item {\n  position: relative;\n  border-radius: 8px;\n  font-size: 13.5px;\n  font-weight: 500;\n  color: var(--y-text-700);\n  transition: background-color 120ms ease, color 120ms ease;\n  margin: 0;\n  width: 100%;\n  box-sizing: border-box;\n}\n.section-item:hover {\n  background-color: var(--y-bg-hover);\n  color: var(--y-text-900);\n}\n.section-item .icon {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 18px;\n  height: 18px;\n  font-size: 17px;\n  color: var(--y-text-500);\n  flex-shrink: 0;\n  transition: color 120ms ease;\n}\n.section-item:hover .icon {\n  color: var(--y-text-700);\n}\n.section-item.active {\n  background-color: var(--y-orange-50);\n  color: var(--y-orange);\n  font-weight: 600;\n  box-shadow: 0 2px 8px -3px rgba(236, 110, 23, 0.15);\n}\n.section-item.active .icon {\n  color: var(--y-orange);\n}\n.section-item.active::before {\n  content: '';\n  position: absolute;\n  left: 0;\n  top: 50%;\n  transform: translateY(-50%);\n  width: 3px;\n  height: 22px;\n  background: var(--y-orange);\n  border-radius: 0 3px 3px 0;\n}\n.section-item .link_text {\n  color: inherit;\n  font: inherit;\n}\n.sidebar-closed .section-item {\n  padding: 8px !important;\n  justify-content: center;\n}\n.sidebar-closed .section-item .link_text {\n  display: none;\n}\n\n/* ============================================================\n   Header controls: language switcher + dark mode toggle\n   ============================================================ */\n.lang-switcher {\n  position: relative;\n  display: inline-flex;\n  align-items: center;\n  gap: 5px;\n  padding: 5px 9px;\n  border-radius: 8px;\n  border: 1px solid var(--y-border);\n  background: var(--y-bg);\n  color: var(--y-text-700);\n  cursor: pointer;\n  font-size: 13px;\n  font-weight: 600;\n  user-select: none;\n  transition: background-color 120ms ease, border-color 120ms ease;\n}\n.lang-switcher:hover {\n  background: var(--y-bg-hover);\n  border-color: var(--y-orange);\n}\n.lang-switcher .lang-label {\n  font-size: 12px;\n  letter-spacing: 0.02em;\n}\n.lang-menu {\n  position: absolute;\n  top: calc(100% + 6px);\n  right: 0;\n  background: var(--y-bg);\n  border: 1px solid var(--y-border);\n  border-radius: 10px;\n  box-shadow: 0 8px 24px rgba(15, 23, 42, 0.12);\n  padding: 4px;\n  z-index: 1300;\n  min-width: 140px;\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n}\n.lang-menu-item {\n  background: transparent;\n  border: 0;\n  padding: 9px 12px;\n  text-align: left;\n  border-radius: 6px;\n  cursor: pointer;\n  font-size: 13px;\n  color: var(--y-text-700);\n  transition: background-color 120ms ease;\n}\n.lang-menu-item:hover {\n  background: var(--y-bg-hover);\n}\n.lang-menu-item.active {\n  background: var(--y-orange-50);\n  color: var(--y-orange);\n  font-weight: 600;\n}\n\n.theme-toggle {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 36px;\n  height: 36px;\n  border-radius: 8px;\n  border: 1px solid var(--y-border);\n  background: var(--y-bg);\n  color: var(--y-text-700);\n  font-size: 18px;\n  transition: background-color 120ms ease, border-color 120ms ease, color 120ms ease;\n}\n.theme-toggle:hover {\n  background: var(--y-bg-hover);\n  border-color: var(--y-orange);\n  color: var(--y-orange);\n}\n\n/* ============================================================\n   DARK MODE — flips the same CSS variables; everything follows\n   ============================================================ */\nbody[data-theme=\"dark\"] {\n  --y-text-900: #f1f5f9;\n  --y-text-700: #cbd5e1;\n  --y-text-500: #94a3b8;\n  --y-text-400: #64748b;\n  --y-bg: #0f172a;\n  --y-bg-soft: #1e293b;\n  --y-bg-hover: #1e293b;\n  --y-border: #334155;\n  --y-orange-50: rgba(236, 110, 23, 0.12);\n  --y-orange-100: rgba(236, 110, 23, 0.22);\n}\nbody[data-theme=\"dark\"] {\n  background-color: var(--y-bg);\n  color: var(--y-text-700);\n}\nbody[data-theme=\"dark\"] .navbar {\n  background-color: var(--y-bg);\n  border-bottom: 1px solid var(--y-border);\n}\nbody[data-theme=\"dark\"] .navbarcontent {\n  color: var(--y-text-700);\n}\nbody[data-theme=\"dark\"] .navbarcontent button,\nbody[data-theme=\"dark\"] .navbarcontent h6,\nbody[data-theme=\"dark\"] .navbarcontent p,\nbody[data-theme=\"dark\"] .navbarcontent span {\n  color: var(--y-text-700);\n}\nbody[data-theme=\"dark\"] .sidebar {\n  background-color: var(--y-bg);\n  border-right: 1px solid var(--y-border);\n}\nbody[data-theme=\"dark\"] .section-item,\nbody[data-theme=\"dark\"] .section-item .link_text,\nbody[data-theme=\"dark\"] .section-item span,\nbody[data-theme=\"dark\"] .sidebar a.section-item {\n  color: #e2e8f0 !important;\n}\nbody[data-theme=\"dark\"] .section-item .icon,\nbody[data-theme=\"dark\"] .section-item .icon svg {\n  color: #cbd5e1 !important;\n  fill: #cbd5e1 !important;\n}\nbody[data-theme=\"dark\"] .section-item:hover,\nbody[data-theme=\"dark\"] .section-item:hover .link_text {\n  color: #ffffff !important;\n  background-color: #1e293b !important;\n}\nbody[data-theme=\"dark\"] .section-item:hover .icon,\nbody[data-theme=\"dark\"] .section-item:hover .icon svg {\n  color: #ffffff !important;\n  fill: #ffffff !important;\n}\nbody[data-theme=\"dark\"] .section-item.active,\nbody[data-theme=\"dark\"] .section-item.active .link_text,\nbody[data-theme=\"dark\"] .section-item.active span {\n  color: #fb923c !important;\n  background-color: rgba(236, 110, 23, 0.18) !important;\n}\nbody[data-theme=\"dark\"] .section-item.active .icon,\nbody[data-theme=\"dark\"] .section-item.active .icon svg {\n  color: #fb923c !important;\n  fill: #fb923c !important;\n}\nbody[data-theme=\"dark\"] .sidebar-section-header {\n  color: #94a3b8 !important;\n}\nbody[data-theme=\"dark\"] .section-item:hover {\n  background-color: var(--y-bg-hover);\n  color: var(--y-text-900);\n}\nbody[data-theme=\"dark\"] .section-item.active {\n  background-color: var(--y-orange-100);\n  color: var(--y-orange);\n}\nbody[data-theme=\"dark\"] .sidebar-section-header {\n  color: var(--y-text-400);\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
